import { NodeEnvironment } from '.';

export const REACT_APP_API_BASE_URL = 'https://dy60pa2s7k.execute-api.us-east-1.amazonaws.com/dev';
  // process.env.NODE_ENV === NodeEnvironment.DEV
  //   ? 'https://dy60pa2s7k.execute-api.us-east-1.amazonaws.com/dev'
  //   : 'https://api.hyo-shinna.com';

export const REACT_APP_IMAGE_BASE_URL = 'https://s3.amazonaws.com/images.hyoshin.na/photos/'
export const REACT_APP_WF_IMAGE_BASE_URL = 'https://s3.amazonaws.com/images.hyoshin.na/woodenfish/'